export default 'document-triage-status-updated';
